import { Box, Typography } from '@mui/material'

type PdfViewerProps = {
  contentType: string
  fileUri: string
  width: number
  height?: number
  extraPdfViewerUrlParams?: string
}

export const PdfViewer = ({
  contentType,
  fileUri,
  width,
  height,
  extraPdfViewerUrlParams,
}: PdfViewerProps) => {
  return (
    <Box>
      <object
        data={`${fileUri}#navpanes=0${extraPdfViewerUrlParams}`}
        type={contentType}
        width={`${width}px`}
        height={`${height}px`}
        style={{ boxShadow: '0px 3px black' }}
      >
        <Typography>
          Sorry, your browser doesn&apos;t support viewing PDF files.
        </Typography>
      </object>
    </Box>
  )
}
